import {Component} from '@angular/core';

@Component({
	selector: 'sis-app',
	template: require('./app.component.html'),
})
export class AppComponent {
	
}
